import React, { useState } from "react";
import { Link } from "react-router";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";
import LegalbirdLoader from "../../../../components/ContentLoader/LegalbirdLoader";
import { getCaseLink, getProductData } from "@/src/services/productService";
import { Helmet } from "react-helmet-async";
import { apiCall } from "@/src/services/apiClient";
import HintBox from "../../../../components/Box/HintBox/HintBox";
import { fromGender } from "@/src/services/formServiceFunctions";
import Button from "@mui/material/Button";
import { STATUS_POWER_OF_ATTORNEY_GRANTED } from "@/src/services/divorce/leadStatus";
import PowerOfAttorney from "../../../../components/Form/Divorce/PowerOfAttorney";
import { FormProvider } from "@/src/provider/Form/FormProvider";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import useProductParams from "../../../../hooks/useProductParams";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";
import { useInvalidateInquiryToCustomer } from "@/src/hooks/queries/inquiryToCustomer";

const PowerOfAttorneyPageDivorce = () => {
  const { productId } = useProductParams();
  const [isLoadingInternal, setIsLoadingInternal] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const productApiUri = getProductData("divorce", "apiUri");
  const { data: divorce, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId)
  });
  const { customer } = useCustomer();
  const formService = getProductData("divorce", "formService");
  const queryClient = useQueryClient();
  const { invalidateInquiryToCustomer } = useInvalidateInquiryToCustomer();

  if (isLoading) {
    return (
      <LayoutAuthenticated>
        <LegalbirdLoader />
      </LayoutAuthenticated>
    );
  }

  if (isComplete || divorce <= STATUS_POWER_OF_ATTORNEY_GRANTED || divorce.powerOfAttorney !== null) {
    return (
      <LayoutAuthenticated>
        <HintBox headline={"Vielen Dank!"}>
          <p>Wir haben Ihre Vollmacht gespeichert und bearbeiten Ihre Scheidung entsprechend weiter.</p>
          <Button variant={"text"} color={"primary"} component={Link} to={getCaseLink(divorce)} fullWidth>
            Zurück zur Scheidung
          </Button>
        </HintBox>
      </LayoutAuthenticated>
    );
  }

  const handleSubmit = async () => {
    setIsLoadingInternal(true);
    await apiCall("PATCH", "/divorces/" + divorce.id + "/power_of_attorney", {
      body: JSON.stringify({
        powerOfAttorney: null,
      }),
    });
    await invalidateInquiryToCustomer();
    setIsLoadingInternal(false);
    setIsComplete(true);
    queryClient.invalidateQueries({
      queryKey: ["/divorces", productId],
    });
  };

  return (
    <FormProvider initialValues={formService.prepareFormData(divorce, customer)} submitAction={handleSubmit}>
      <LayoutAuthenticated>
        <Helmet>
          <title>Vollmacht | Legalbird</title>
        </Helmet>
        <HintBox headline={"Bitte erteilen Sie Ihre Vollmacht"}>
            <p>
              Achtung: Auf dieser Vollmacht muss{" "}
              <strong>
                {fromGender(divorce.client.gender)} {divorce.client.givenName} {divorce.client.familyName}
              </strong>{" "}
              unterzeichnen damit wir weiter tätig werden können.
            </p>
          </HintBox>
        <PowerOfAttorney product={divorce} submitProps={{ isLoading: isLoadingInternal, isMinimal: true }} />
      </LayoutAuthenticated>
    </FormProvider>
  );
};
export default PowerOfAttorneyPageDivorce;
